import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    title: {
      fontSize: '24px',
      color: 'black',
      padding:'15px 20px'
    },
    paper: {
      borderRadius: '15px',
      padding: '20px'
    },
  })
);

export default useStyles;
